import { useState } from "react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import { Flashbar } from "@amzn/awsui-components-react";

import NavigationBreadcrumbs from "../../common/navigation/NavigationBreadcrumbs";
import SideNavigationMenu from "../../common/navigation/SideNavigationMenu";
import Paths from "../../common/paths/paths";
import { useFlashBarItems } from "../../common/UseFlashBarItems/useFlashBarItems";
import { BulkOrdersTable } from "../../components/BulkOrders/BulkOrdersTable";
import useAppDrawers from "../../components/ChatbotWidget/useAppDrawers";

const breadcrumbs = {
    items: [
        { text: Paths.Admin.name, href: Paths.uploadLicense.url },
        { text: Paths.bulkOrders.name, href: Paths.bulkOrders.url },
    ],
};

const BulkOrdersPage = () => {
    const [navigationOpen, setNavigationOpen] = useState(false);
    const flashBarItemsHook = useFlashBarItems();
    const drawerProps = useAppDrawers();

    return (
        <AppLayout
            content={<BulkOrdersTable useFlashBarItemsActions={flashBarItemsHook.actions} />}
            breadcrumbs={<NavigationBreadcrumbs items={breadcrumbs.items} />}
            navigation={<SideNavigationMenu />}
            navigationOpen={navigationOpen}
            notifications={<Flashbar items={flashBarItemsHook.flashBarItems} stackItems />}
            onNavigationChange={(event: any) => setNavigationOpen(event.detail.open)}
            toolsHide={true}
            {...drawerProps}
        />
    );
};

export default BulkOrdersPage;
